/**
 * O interruptor "Texto das publicações" da página Justificativas
 * (2026-10-21): abre ou fecha, de uma vez, o painel com o texto da
 * publicação em todos os cards. A escolha fica no `localStorage` e é lida
 * no PRIMEIRO render (num efeito, a página abriria fechada e piscaria).
 * Armazenamento bloqueado ou valor estranho cai em "fechado".
 */

export const WHY_TEXT_OPEN_KEY = "reputaition.why_text_open";

export function readWhyTextOpen(): boolean {
  try {
    return window.localStorage.getItem(WHY_TEXT_OPEN_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeWhyTextOpen(open: boolean): void {
  try {
    window.localStorage.setItem(WHY_TEXT_OPEN_KEY, open ? "1" : "0");
  } catch {
    /* armazenamento bloqueado: a escolha vale só nesta visita */
  }
}
